import { render, staticRenderFns } from "./UserSessionsDrawer.vue?vue&type=template&id=4d97c99f&scoped=true"
import script from "./UserSessionsDrawer.vue?vue&type=script&lang=js"
export * from "./UserSessionsDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserSessionsDrawer.vue?vue&type=style&index=0&id=4d97c99f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97c99f",
  null
  
)

export default component.exports